import {
  WixPatternsContainerOverridesProvider,
  useWixPatternsContainerOverrides,
} from '@wix/bex-core/react';
import React, { ReactNode, useState } from 'react';
import { WixPatternsContainerParams, QueryCache } from '@wix/bex-core';

export interface WixPatternsTestProviderProps {
  children: ReactNode;
  overrides?: Partial<WixPatternsContainerParams>;
}

/**
 * @deprecated
 * use `WixPatternsTestProvider`
 */
export const CairoTestProvider = (props: WixPatternsTestProviderProps) => {
  const { overrides, children } = props;

  const existingCairoContainerOverrides = useWixPatternsContainerOverrides();

  const [cairoContainerOverrides] = useState(
    (): Partial<WixPatternsContainerParams> => ({
      queryCache: new QueryCache(),
      ...existingCairoContainerOverrides,
      ...overrides,
    }),
  );

  return (
    <WixPatternsContainerOverridesProvider value={cairoContainerOverrides}>
      {children}
    </WixPatternsContainerOverridesProvider>
  );
};

export const WixPatternsTestProvider = CairoTestProvider;
